import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import api from '@/i18n/locales/en/api.json';
import common from '@/i18n/locales/en/common.json';
import companions from '@/i18n/locales/en/companions.json';
import dashboard from '@/i18n/locales/en/dashboard.json';
import error from '@/i18n/locales/en/error.json';
import identify from '@/i18n/locales/en/identify.json';
import invite from '@/i18n/locales/en/invite.json';
import mobile from '@/i18n/locales/en/mobile.json';
import parentalConsent from '@/i18n/locales/en/parentalConsent.json';
import selfie from '@/i18n/locales/en/selfie.json';
import signup from '@/i18n/locales/en/signup.json';
import success from '@/i18n/locales/en/success.json';
import terms from '@/i18n/locales/en/terms.json';
import welcome from '@/i18n/locales/en/welcome.json';
import ptBrApi from '@/i18n/locales/pt-BR/api.json';
import ptBrCommon from '@/i18n/locales/pt-BR/common.json';
import ptBrCompanions from '@/i18n/locales/pt-BR/companions.json';
import ptBrDashboard from '@/i18n/locales/pt-BR/dashboard.json';
import ptBrError from '@/i18n/locales/pt-BR/error.json';
import ptBrIdentify from '@/i18n/locales/pt-BR/identify.json';
import ptBrInvite from '@/i18n/locales/pt-BR/invite.json';
import ptBrMobile from '@/i18n/locales/pt-BR/mobile.json';
import ptBrParentalConsent from '@/i18n/locales/pt-BR/parentalConsent.json';
import ptBrSelfie from '@/i18n/locales/pt-BR/selfie.json';
import ptBrSignup from '@/i18n/locales/pt-BR/signup.json';
import ptBrSuccess from '@/i18n/locales/pt-BR/success.json';
import ptBrTerms from '@/i18n/locales/pt-BR/terms.json';
import ptBrWelcome from '@/i18n/locales/pt-BR/welcome.json';

export const COMMON_NAMESPACE = 'common';
export const WELCOME_NAMESPACE = 'welcome';
export const TERMS_NAMESPACE = 'terms';
export const SIGNUP_NAMESPACE = 'signup';
export const PARENTAL_CONSENT_NAMESPACE = 'parentalConsent';
export const ERROR_NAMESPACE = 'error';
export const SUCCESS_NAMESPACE = 'success';
export const SELFIE_NAMESPACE = 'selfie';
export const MOBILE_NAMESPACE = 'mobile';
export const API_NAMESPACE = 'api';
export const DASHBOARD_NAMESPACE = 'dashboard';
export const IDENTIFY_NAMESPACE = 'identify';
export const COMPANIONS_NAMESPACE = 'companions';
export const INVITE_NAMESPACE = 'invite';

export const NAMESPACES = [
  COMMON_NAMESPACE,
  WELCOME_NAMESPACE,
  TERMS_NAMESPACE,
  SIGNUP_NAMESPACE,
  PARENTAL_CONSENT_NAMESPACE,
  ERROR_NAMESPACE,
  SUCCESS_NAMESPACE,
  SELFIE_NAMESPACE,
  MOBILE_NAMESPACE,
  API_NAMESPACE,
  DASHBOARD_NAMESPACE,
  IDENTIFY_NAMESPACE,
  COMPANIONS_NAMESPACE,
  INVITE_NAMESPACE,
] as const;

void i18n.use(initReactI18next).init({
  lng: 'pt-BR',
  fallbackLng: 'pt-BR',
  defaultNS: COMMON_NAMESPACE,
  ns: [...NAMESPACES],
  resources: {
    en: {
      [COMMON_NAMESPACE]: common,
      [WELCOME_NAMESPACE]: welcome,
      [TERMS_NAMESPACE]: terms,
      [SIGNUP_NAMESPACE]: signup,
      [PARENTAL_CONSENT_NAMESPACE]: parentalConsent,
      [ERROR_NAMESPACE]: error,
      [SUCCESS_NAMESPACE]: success,
      [SELFIE_NAMESPACE]: selfie,
      [MOBILE_NAMESPACE]: mobile,
      [API_NAMESPACE]: api,
      [DASHBOARD_NAMESPACE]: dashboard,
      [IDENTIFY_NAMESPACE]: identify,
      [COMPANIONS_NAMESPACE]: companions,
      [INVITE_NAMESPACE]: invite,
    },
    'pt-BR': {
      [COMMON_NAMESPACE]: ptBrCommon,
      [WELCOME_NAMESPACE]: ptBrWelcome,
      [TERMS_NAMESPACE]: ptBrTerms,
      [SIGNUP_NAMESPACE]: ptBrSignup,
      [PARENTAL_CONSENT_NAMESPACE]: ptBrParentalConsent,
      [ERROR_NAMESPACE]: ptBrError,
      [SUCCESS_NAMESPACE]: ptBrSuccess,
      [SELFIE_NAMESPACE]: ptBrSelfie,
      [MOBILE_NAMESPACE]: ptBrMobile,
      [API_NAMESPACE]: ptBrApi,
      [DASHBOARD_NAMESPACE]: ptBrDashboard,
      [IDENTIFY_NAMESPACE]: ptBrIdentify,
      [COMPANIONS_NAMESPACE]: ptBrCompanions,
      [INVITE_NAMESPACE]: ptBrInvite,
    },
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
